import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';

export const useGetActivities = () => {
  const [isFetching, setFetching] = useState(false);
  const [activityItems, setActivityItems] = useState([]);

  return {
    isFetching,
    activityItems,
    onLoad: async () => {
      try {
        setFetching(true);
        const { data } = await AxiosPublic.get('/activities');

        setActivityItems(data.map(item => ({ value: item.id, label: item.name })));
        setFetching(false);
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
